enum ActionTypes {
  STORE_SEARCH = 'STORE_SEARCH'
}

export default ActionTypes;
